import type { FooterItem, MainNavItem } from '@/types/nav.type'

export const HEADER_LAYOUT_PRESETS = ['logo-left', 'split', 'centered', 'general-v1-overlay'] as const
export const HEADER_WIDTH_OPTIONS = ['auto', 'sm', 'md', 'lg', 'full'] as const
export const HEADER_SPACING_OPTIONS = ['compact', 'normal', 'relaxed'] as const
export const FOOTER_LAYOUT_PRESETS = ['default', 'centered', 'minimal-general-v1'] as const
export const FOOTER_WIDTH_OPTIONS = ['content', 'wide', 'full'] as const
export const FOOTER_SPACING_OPTIONS = ['compact', 'normal', 'relaxed'] as const

export type HeaderLayoutPreset = (typeof HEADER_LAYOUT_PRESETS)[number]
export type HeaderSectionWidth = (typeof HEADER_WIDTH_OPTIONS)[number]
export type HeaderSpacing = (typeof HEADER_SPACING_OPTIONS)[number]
export type FooterLayoutPreset = (typeof FOOTER_LAYOUT_PRESETS)[number]
export type FooterWidth = (typeof FOOTER_WIDTH_OPTIONS)[number]
export type FooterSpacing = (typeof FOOTER_SPACING_OPTIONS)[number]
export type HeaderActionType = 'link' | 'button' | 'icon'
export type HeaderActionVariant = 'default' | 'outline' | 'secondary' | 'ghost' | 'link'

export interface HeaderActionConfig {
  type: HeaderActionType
  label: string
  href: string
  icon?: string
  variant?: HeaderActionVariant
  external?: boolean
}

export interface HeaderConfig {
  layoutPreset?: HeaderLayoutPreset
  sticky?: boolean
  showBorder?: boolean
  showLeftSection?: boolean
  showRightSection?: boolean
  containerWidth?: HeaderSectionWidth
  leftSectionWidth?: HeaderSectionWidth
  rightSectionWidth?: HeaderSectionWidth
  spacing?: HeaderSpacing
  navItems?: MainNavItem[]
  mobileNavItems?: MainNavItem[]
  rightActions?: HeaderActionConfig[]
  /** Template-specific preset identifier for scoped header styling. */
  templatePreset?: string
  /** Whether to show the Forum navigation link. Defaults to true. */
  showForum?: boolean
  /** Whether to show the Chat widget. Defaults to true. */
  showChat?: boolean
}

export interface FooterConfig {
  layoutPreset?: FooterLayoutPreset
  showLogo?: boolean
  showLinkGroups?: boolean
  showSocialLinks?: boolean
  showCopyright?: boolean
  showBorder?: boolean
  containerWidth?: FooterWidth
  spacing?: FooterSpacing
  linkGroups?: FooterItem[]
}
